import { render } from "./Karne.vue?vue&type=template&id=448ef78e&scoped=true"
import script from "./Karne.vue?vue&type=script&lang=js"
export * from "./Karne.vue?vue&type=script&lang=js"

import "./Karne.vue?vue&type=style&index=0&id=448ef78e&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-448ef78e"]])

export default __exports__